import { merge, ThemeUIStyleObject } from "theme-ui"
import baseTheme from "@lekoarts/gatsby-theme-minimal-blog/src/gatsby-plugin-theme-ui"

type Theme = {
  text?: Record<string, ThemeUIStyleObject>
}

const theme = merge(baseTheme, {
  colors: {
    heading: `#212630`,
    text: `#212630`,
  },
  text: {
    heading: {
      fontWeight: 600,
      lineHeight: 1.2,
      letterSpacing: `-0.01em`,
      color: `heading`,
    },
    caseStudyTitle: {
      variant: `styles.h3`,
      fontWeight: 400,
      mt: 0,
      mb: 2,
    },
    caseStudyDescription: {
      variant: `styles.p`,
      mt: 0,
      color: `text`,
      fontSize: [`0.95rem`, `1rem`, `1.05rem`],
    },
  },
  styles: {
    p: {
      fontSize: [`1rem`, `1.0625rem`, `1.125rem`],
      letterSpacing: `-0.003em`,
      lineHeight: 1.7,
      color: `text`,
      wordBreak: `break-word`,
    },
    ul: {
      li: {
        fontSize: [`1rem`, `1.0625rem`, `1.125rem`],
        letterSpacing: `-0.003em`,
        lineHeight: 1.7,
      },
    },
    ol: {
      li: {
        fontSize: [`1rem`, `1.0625rem`, `1.125rem`],
        letterSpacing: `-0.003em`,
        lineHeight: 1.7,
      },
    },
    h1: {
      variant: `text.heading`,
      fontSize: [`2.25rem`, `2.75rem`, `3rem`],
      mt: 0,
      mb: 3,
    },
    h2: {
      variant: `text.heading`,
      fontSize: [`1.75rem`, `2.125rem`, `2.375rem`],
      mt: 5,
      mb: 3,
    },
    h3: {
      variant: `text.heading`,
      fontSize: [`1.375rem`, `1.5rem`, `1.625rem`],
      mt: 4,
      mb: 2,
    },
    h4: {
      variant: `text.heading`,
      fontSize: [`1.125rem`, `1.25rem`, `1.375rem`],
      mt: 3,
      mb: 2,
    },
    h5: {
      variant: `text.heading`,
      fontSize: [`1rem`, `1.0625rem`],
      mt: 3,
      mb: 2,
    },
    h6: {
      variant: `text.heading`,
      fontSize: `0.9375rem`,
      mt: 3,
      mb: 2,
    },
  },
} as Theme)

export default theme
